export default "__VITE_ASSET__BDY2ijwa__"